import { Avatar } from "@mui/material";

const CountryAvatar = ({ countryCode }) => {
  return <Avatar area-label="country-avatar-component" src={`https://api.nubet.com/media/flags/${(countryCode = "" ? "INT" : countryCode)}.png`} alt="flag" sx={{ height: "1.2em", width: "1.2em" }} />;
};

export default CountryAvatar;
